class ProductMarketplaceFinanceProfit{
    constructor({market, base, roi, ros}){
        this.market = market;
        this.base = base;
        this.roi = roi;
        this.ros = ros;
    }
}

export { ProductMarketplaceFinanceProfit };